module.exports = __webpack_public_path__ + "static/media/chevron-droite-small.fd9802dc.png";